// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__xqNxB","footer":"ReportModalFilter_footer__1cLO9"};